var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart24Px = function SvgCart24Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.175 22.475q-.75 0-1.275-.525a1.74 1.74 0 0 1-.525-1.275q0-.75.525-1.275t1.275-.525 1.275.525.525 1.275-.525 1.275-1.275.525m10 0q-.75 0-1.275-.525a1.74 1.74 0 0 1-.525-1.275q0-.75.525-1.275t1.275-.525 1.275.525.525 1.275-.525 1.275-1.275.525m-12.05-18H19.85q.575 0 .875.525t0 1.05l-3.375 6.075q-.274.475-.713.762a1.7 1.7 0 0 1-.962.288H8.1l-1.4 2.6h12.275v1.5H6.925q-1.05 0-1.513-.7T5.425 15l1.6-2.95L3.225 4h-1.95V2.5H4.2z"
  })));
};
export { SvgCart24Px as ReactComponent };
export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJzdGF0aWMvbWVkaWEvY2FydDI0cHguMThiYzVlZTQuc3ZnIjs=";